<app-loader [isLoading]="isLoading"></app-loader>

<div class="tenant-mgmt">
  <!-- Header -->
  <div class="tenant-mgmt__header">
    <div>
      <h4 class="tenant-mgmt__title">{{ "tenantMgmt.Title" | translate }}</h4>
      <p class="tenant-mgmt__subtitle">{{ "tenantMgmt.Subtitle" | translate }}</p>
    </div>
    <button type="button" class="btn btn-primary" (click)="openAdd()" *ngIf="isPlatformAdmin">
      <span class="ico-plus-square me-1"></span>
      <span>{{ "tenantMgmt.AddTenant" | translate }}</span>
    </button>
  </div>

  <!-- Search -->
  <div class="tenant-mgmt__toolbar">
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="searchTerm"
        (keyup.enter)="applySearch()"
        [placeholder]="'tenantMgmt.SearchPlaceholder' | translate"
      />
      <button class="btn btn-outline-primary" type="button" (click)="applySearch()">
        <i class="ico-search"></i>
        <span>{{ "tenantMgmt.Search" | translate }}</span>
      </button>
    </div>
  </div>

  <!-- Table -->
  <div class="table-responsive tenant-mgmt__table">
    <table class="table align-middle">
      <thead>
        <tr>
          <th>{{ "tenantMgmt.Name" | translate }}</th>
          <th>{{ "tenantMgmt.Url" | translate }}</th>
          <th>{{ "tenantModules.TypeAndModules" | translate }}</th>
          <th>{{ "tenantMgmt.Admin" | translate }}</th>
          <th>{{ "tenantMgmt.Email" | translate }}</th>
          <th class="text-end">{{ "tenantMgmt.Actions" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of tenants; trackBy: trackTenant">
          <td>
            <div class="fw-semibold">{{ item.tenant.nameEn }}</div>
            <div class="text-muted small">{{ item.tenant.nameAr }}</div>
          </td>
          <td>{{ item.tenant.url }}</td>
          <td>
            <div class="tenant-mgmt__type">{{ typeLabelKey(item) | translate }}</div>
            <div class="tenant-mgmt__modules">
              <span class="tenant-mgmt__module" *ngFor="let m of tenantModules(item)">{{ moduleLabelKey(m) | translate }}</span>
            </div>
          </td>
          <td>{{ item.teacher.fullNameEn }}</td>
          <td>{{ item.teacher.email }}</td>
          <td class="text-end text-nowrap">
            <button
              *ngIf="isPlatformAdmin"
              type="button"
              class="btn btn-sm btn-outline-primary me-1"
              (click)="openModules(item)"
              [title]="'tenantModules.EditModules' | translate"
              [attr.aria-label]="'tenantModules.EditModules' | translate">
              <i class="bi bi-toggles" aria-hidden="true"></i>
            </button>
            <button
              type="button"
              class="btn btn-sm btn-outline-secondary me-1"
              (click)="openEdit(item)"
              [title]="'tenantMgmt.Edit' | translate"
            >
              <i class="ico-edit"></i>
            </button>
            <button
              *ngIf="isPlatformAdmin"
              type="button"
              class="btn btn-sm btn-outline-danger"
              (click)="confirmDelete(item)"
              [title]="'tenantMgmt.Delete' | translate"
            >
              <i class="ico-trash"></i>
            </button>
          </td>
        </tr>
        <tr *ngIf="!isLoading && tenants.length === 0">
          <td colspan="6" class="text-center text-muted py-4">
            {{ "tenantMgmt.Empty" | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="tenant-mgmt__pagination" *ngIf="totalPages > 1">
    <button
      class="btn btn-sm btn-outline-secondary"
      [disabled]="search.pageNumber <= 1"
      (click)="goToPage(search.pageNumber - 1)"
    >
      {{ "tenantMgmt.Prev" | translate }}
    </button>
    <span class="tenant-mgmt__page-info" dir="ltr">
      {{ search.pageNumber }} / {{ totalPages }}
    </span>
    <button
      class="btn btn-sm btn-outline-secondary"
      [disabled]="search.pageNumber >= totalPages"
      (click)="goToPage(search.pageNumber + 1)"
    >
      {{ "tenantMgmt.Next" | translate }}
    </button>
  </div>
</div>

<!-- Delete confirmation -->
<app-confirm-dialog
  #confirmDialog
  [title]="'app.ConfirmDeletionTitle' | translate"
  [message]="'app.ConfirmDeletionMessage' | translate"
  (confirmed)="onDeleteConfirmed($event)"
>
</app-confirm-dialog>

<!-- Add / Edit modal -->
<div class="custom-modal" [ngClass]="{ show: isModalShow }">
  <div class="modal-content">
    <div class="modal-content__header">
      <h5>
        {{
          (isEditMode ? "tenantMgmt.EditTenant" : "tenantMgmt.AddTenant")
            | translate
        }}
      </h5>
      <a (click)="closeModal()" class="close"><i class="ico-close"></i></a>
    </div>

    <form class="h-100" [formGroup]="form" (ngSubmit)="submit()">
      <div class="modal-content__body">
        <h6 class="tenant-mgmt__section">{{ "tenantMgmt.TenantDetails" | translate }}</h6>
        <div class="row g-3">
          <div class="col-lg-6 col-12">
            <label class="form-label" for="nameEn">{{ "tenantMgmt.NameEn" | translate }}</label>
            <input id="nameEn" type="text" formControlName="nameEn" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="nameAr">{{ "tenantMgmt.NameAr" | translate }}</label>
            <input id="nameAr" type="text" formControlName="nameAr" class="form-control" />
          </div>
          <div class="col-12">
            <label class="form-label" for="url">{{ "tenantMgmt.Url" | translate }}</label>
            <input id="url" type="text" formControlName="url" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="descriptionEn">{{ "tenantMgmt.DescriptionEn" | translate }}</label>
            <textarea id="descriptionEn" formControlName="descriptionEn" class="form-control" rows="2"></textarea>
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="descriptionAr">{{ "tenantMgmt.DescriptionAr" | translate }}</label>
            <textarea id="descriptionAr" formControlName="descriptionAr" class="form-control" rows="2"></textarea>
          </div>
        </div>

        <h6 class="tenant-mgmt__section mt-4">{{ "tenantMgmt.AdminDetails" | translate }}</h6>
        <div class="row g-3">
          <div class="col-lg-6 col-12">
            <label class="form-label" for="fullNameEn">{{ "tenantMgmt.FullNameEn" | translate }}</label>
            <input id="fullNameEn" type="text" formControlName="fullNameEn" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="fullNameAr">{{ "tenantMgmt.FullNameAr" | translate }}</label>
            <input id="fullNameAr" type="text" formControlName="fullNameAr" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="email">{{ "tenantMgmt.Email" | translate }}</label>
            <input id="email" type="email" formControlName="email" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="phoneNumber">{{ "tenantMgmt.Phone" | translate }}</label>
            <input id="phoneNumber" type="text" formControlName="phoneNumber" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="dateOfBirth">{{ "tenantMgmt.DateOfBirth" | translate }}</label>
            <input id="dateOfBirth" type="date" formControlName="dateOfBirth" class="form-control" />
          </div>
          <div class="col-lg-6 col-12">
            <label class="form-label" for="genderId">{{ "tenantMgmt.Gender" | translate }}</label>
            <select id="genderId" formControlName="genderId" class="form-control">
              <option value="">{{ "tenantMgmt.SelectGender" | translate }}</option>
              <option value="1">{{ "tenantMgmt.Male" | translate }}</option>
              <option value="2">{{ "tenantMgmt.Female" | translate }}</option>
            </select>
          </div>

          <!-- Credentials: only when creating a new tenant -->
          <ng-container *ngIf="!isEditMode">
            <div class="col-lg-6 col-12">
              <label class="form-label" for="userName">{{ "tenantMgmt.Username" | translate }}</label>
              <input id="userName" type="text" formControlName="userName" class="form-control" />
            </div>
            <div class="col-lg-6 col-12"></div>
            <div class="col-lg-6 col-12">
              <label class="form-label" for="password">{{ "tenantMgmt.Password" | translate }}</label>
              <input id="password" type="password" formControlName="password" class="form-control" />
            </div>
            <div class="col-lg-6 col-12">
              <label class="form-label" for="confirmPassword">{{ "tenantMgmt.ConfirmPassword" | translate }}</label>
              <input id="confirmPassword" type="password" formControlName="confirmPassword" class="form-control" />
              <small class="text-danger" *ngIf="form.errors?.['mismatch']">
                {{ "tenantMgmt.PasswordMismatch" | translate }}
              </small>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="modal-content__footer">
        <div class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
            {{ "tenantMgmt.Cancel" | translate }}
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
            {{ (isEditMode ? "tenantMgmt.Save" : "tenantMgmt.Create") | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>

<!-- Type & modules dialog (platform Administrator) -->
<div class="tenant-mgmt__backdrop" *ngIf="modulesTarget" (click)="closeModules()"></div>
<div class="tenant-mgmt__dialog" *ngIf="modulesTarget" role="dialog" aria-modal="true" aria-labelledby="tenantModulesDialogTitle">
  <div class="tenant-mgmt__dialog-head">
    <div>
      <h5 class="mb-0" id="tenantModulesDialogTitle">{{ "tenantModules.EditModules" | translate }}</h5>
      <div class="text-muted small">{{ modulesTarget.tenant.nameEn }} · <span dir="ltr">{{ modulesTarget.tenant.url }}</span></div>
    </div>
    <button type="button" class="btn-close" (click)="closeModules()" [attr.aria-label]="'tenantMgmt.Cancel' | translate"></button>
  </div>
  <div class="tenant-mgmt__dialog-body">
    <app-tenant-modules-picker
      [compact]="true"
      [type]="modulesType"
      [modules]="modulesValue"
      [disabled]="isSavingModules"
      (typeChange)="modulesType = $event"
      (modulesChange)="modulesValue = $event">
    </app-tenant-modules-picker>
  </div>
  <div class="tenant-mgmt__dialog-foot">
    <button type="button" class="btn btn-outline-secondary" (click)="closeModules()">
      {{ "tenantMgmt.Cancel" | translate }}
    </button>
    <button type="button" class="btn btn-primary" (click)="saveModules()"
      [disabled]="isSavingModules || modulesValue.length === 0">
      <span *ngIf="isSavingModules" class="spinner-border spinner-border-sm me-1" aria-hidden="true"></span>
      {{ "tenantModules.Save" | translate }}
    </button>
  </div>
</div>
